export enum EventType {
  SearchHistory = 'SearchHistory', //old ui topbar search
  AddToWorkspace = 'AddToWorkspace', //add to myspace
  AddToFavourites = 'AddToFavourites', //old ui favourites
  AppRated = 'AppRated', //old ui app rated
  UserGuideAccessed = 'UserGuideAccessed', //app user guide accessed
  LazyLoadSuccess = 'LazyLoadSuccess',
  LazyLoadFailed = 'LazyLoadFailed',
  ErrorBoundary = 'ErrorBoundary', //log error
  TopicQueried = 'TopicQueried', //smart data topic queried
  PortalVisit = 'PortalVisit',
  BannerClick = 'BannerClick', //banner button click

  //workspace related events
  ClientAppEvent = 'ClientAppEvent', //track iframe app events
  WorkspaceLaunched = 'WorkspaceLaunched', //active workspace
  WorkspaceAdded = 'WorkspaceAdded', //add new workspace
  WorkspaceRemoved = 'WorkspaceRemoved', //remove workspace
  WorkspaceAppLaunched = 'WorkspaceAppLaunched', //workspace launch new app
  WorkspaceAppAdded = 'WorkspaceAppAdded', //add app from quick launch
  WorkspaceAppRemoved = 'WorkspaceAppRemoved', //workspace app closed
  WorkspaceActiveApps = 'WorkspaceActiveApps', //active apps in workspace

  //chat related events
  AliFeedbackClicked = 'AliFeedbackClicked', //submit heedback from chat header is clicked
  PromptCardClicked = 'PromptCardClicked', //prompt library card click
  NewChatButtonClicked = 'NewChatButtonClicked',
  ChatHistoryClicked = 'ChatHistoryClicked',
  AliIconClicked = 'AliIconClicked',
  IsCitationOpened = 'IsCitationOpened',
  CitationPreviewOpened = 'CitationPreviewOpened', //document citation preview opened from chat
  CitationPreviewInteraction = 'CitationPreviewInteraction', //user action on citation preview (zoom, navigate, highlight nav)
  CitationPreviewError = 'CitationPreviewError', //error loading citation preview
  CitationPreviewDownloaded = 'CitationPreviewDownloaded', //document downloaded from citation preview
  ChatFeedback = 'ChatFeedback', //chat feedback submit
  MicrophoneUsed = 'MicrophoneUsed',
  SpeakerUsed = 'SpeakerUsed',
  ModelVersionUsed = 'ModelVersionUsed',
  ChatMessageDetails = 'ChatMessageDetails',
  IsCompareResponseClicked = 'IsCompareResponseClicked',
  IsMaximizeCodeClicked = 'IsMaximizeCodeClicked',
  JoinEarlyAdopter = 'JoinEarlyAdopter', //ali attestation modal
  ResourceUsed = 'ResourceUsed', //uploaded files

  //data marketplace related events
  IsMarketplaceClicked = 'IsMarketplaceClicked',
  SemanticSearchTriggered = 'SemanticSearchTriggered',
  DataPreviewDownloaded = 'DataPreviewDownloaded',
  AdminGetDataProductList = 'AdminGetDataProductList',
  DMDetailsClicked = 'DMDetailsClicked',
  DMSchemaClicked = 'DMSchemaClicked',
  DMAdminSchemaClicked = 'DMAdminSchemaClicked',
  DMPreviewClicked = 'DMPreviewClicked',
  DMAddToDatabox = 'DMAddToDatabox',
  DMAddToDataboxClicked = 'DMAddToDataboxClicked',
  DMAIChat = 'DMAIChat',
  DMDataHub = 'DMDataHub',
  DMSearchSubmitted = 'DMSearchSubmitted',
  DMFilterApplied = 'DMFilterApplied',
  DMDomainSelected = 'DMDomainSelected',
  DMViewSwitched = 'DMViewSwitched',
  DMTabSwitched = 'DMTabSwitched',
  DMRequestAccess = 'DMRequestAccess',
  DMViewDetails = 'DMViewDetails',
  DMSmartDataHubOpened = 'DMSmartDataHubOpened',
  DMDatasetDownloaded = 'DMDatasetDownloaded',
  DMAdminProductUpdated = 'DMAdminProductUpdated',
  DMAdminProductDeleted = 'DMAdminProductDeleted',
  DMAdminRoleAdded = 'DMAdminRoleAdded',
  DMAdminRoleDeleted = 'DMAdminRoleDeleted',
  DMAdminQueryAdded = 'DMAdminQueryAdded',
  DMAdminQueryDeleted = 'DMAdminQueryDeleted',
  DMSearchCleared = 'DMSearchCleared',
  DMFilterCleared = 'DMFilterCleared',
  DMDomainExplored = 'DMDomainExplored',
  DMPreviewFiltersRun = 'DMPreviewFiltersRun',
  DMAdminSchemaUpdated = 'DMAdminSchemaUpdated',
  DMFileDownloaded = 'DMFileDownloaded',
  ChatCodeCopied = 'ChatCodeCopied',
  ChatCodeDownloaded = 'ChatCodeDownloaded',
  ChatArtifactCopied = 'ChatArtifactCopied',
  ChatArtifactDownloaded = 'ChatArtifactDownloaded',

  //team related events
  ManageDatabox = 'ManageDatabox', //add/edit databox
  OwnerAdded = 'OwnerAdded', // add owner to public databox
  DeleteDatabox = 'DeleteDatabox', //delete databox
  RemoveTeamMember = 'RemoveTeamMember', //remove team member
  UpdateTeamMemberRole = 'UpdateTeamMemberRole' //update team member role
}

export enum Role {
  Admin = 'InvDesktop-Admin',
  Contributor = 'InvDesktop-Contributor'
}
